<template>
	<input
			v-bind:value="value"
			v-on:input="onDateInput"
	/>
</template>

<script>
import $ from 'jquery'

export default {
	name: "DatePicker",
	mounted: function () {
		let that = this
		$(this.$el).datepicker({
			dateFormat: this.dateFormat,
			onSelect: function (date) {
				that.$emit('input', date);
			}
		})
	},
	methods: {
		onDateInput: function (event) {
			this.$emit('input', event.target.value)
		}
	},
	props: {
		dateFormat: String,
		value: String
	},
	beforeDestroy: function () {
		$(this.$el).datepicker('hide').datepicker('destroy');
	}
}
</script>

<style scoped>

</style>